'use strict';

var d3 = require('d3');
var _ = require('lodash');
var drawUtils = require('../utils/drawUtils');

var continuousColumn = {};

continuousColumn.updateColumn = function (_g, data, tweenTime, setBrush, similarPatientsFilter) {

  if (data.column.NA.value) {
    continuousColumn.updateNAColumn(_g, data);
  };

  if (data.column.violinData) {
    continuousColumn.updateViolin(_g, data, tweenTime);
  };

  var yAxis = d3.axisLeft().scale(data.column.scaleY);

  var axis = _g.selectAll('#yAxis').data([data]);

  axis.enter().append("g").attr('id', 'yAxis').attr("class", "axis").attr("transform", "translate(" + [0, 0] + ")").call(yAxis).each(function (d) {
    setBrush(_g, data);
  });

  axis.call(yAxis);

  axis.exit().remove();

  var y = 0;
  var opacity = 0;
  if (similarPatientsFilter.brushedSelection[data.column.id]) {
    var selection = similarPatientsFilter.brushedSelection[data.column.id];
    y = selection[0] + (selection[1] - selection[0]) / 2;
    opacity = 0.9;
  }

  var metricLabel = _g.selectAll('#gLabel').data([data.metricLabel]);

  metricLabel.enter().append('g').attr('id', 'gLabel').attr("transform", "translate(" + [0, y] + ")").each(function (d) {
    var g = d3.select(this);

    var bckgrNode = g.append('rect');

    bckgrNode.attr('id', 'bckgr-label').attr('height', 18).attr('width', 64).attr('rx', 3).attr('ry', 3).attr('x', data.column.width - 6).attr('y', -9).attr('fill', '#fff').attr('opacity', opacity);

    var textNode = g.append('text');
    textNode.attr('id', 'metric-label').attr('class', 'pp-svg-axis-label').attr('x', data.column.width).attr('y', 2).text(data.metricLabel);

    var w = continuousColumn.getComputedLength(textNode);

    bckgrNode.attr('width', w);
  });

  metricLabel.attr("transform", "translate(" + [0, y] + ")").each(function (d) {
    var g = d3.select(this);
    var textNode = g.select('#metric-label');
    textNode.text(data.metricLabel);

    var w = continuousColumn.getComputedLength(textNode);
    g.select('#bckgr-label').attr('width', w).attr('opacity', opacity);
  });

  metricLabel.exit().remove();
};

continuousColumn.getComputedLength = function (textNode) {
  var bbox = textNode.node().getBBox();
  return bbox.width + 12;
};

continuousColumn.updateNAColumn = function (_g, data) {

  var metric = (data.column.NA.perc * 100).toFixed(0) + '% (' + data.column.NA.value + ')';

  var categoryNA = _g.selectAll('#na-category').data([data.column.NA]);

  categoryNA.enter().append('g').attr('id', 'na-category').attr('key', 'NA').each(function (d) {
    var g = d3.select(this);

    var pos = { x: -data.column.width / 2 };

    g.append('rect').attr('id', 'rect-na')
    //.attr('x', -data.column.width/2)
    .attr('x', 0).attr('width', 1).attr('y', d.y).attr('height', d.height).attr('fill', '#ccc');
    //.attr('stroke', "#fff")

    g.append('text').attr('id', 'label').attr('class', 'pp-svg-axis-label').attr('x', -8).attr('y', d.yMean).attr('text-anchor', 'end').style('font-size', 10 + 'px').text('NA');

    g.append('text').attr('id', 'metric').attr('class', 'pp-svg-axis-label').attr('x', 8).attr('y', d.yMean).style('font-size', 10 + 'px').text(metric);
  });

  categoryNA.each(function (d) {

    var g = d3.select(this);
    g.select('#rect-na').attr('y', d.y).attr('height', d.height);

    g.select('#metrix').attr('y', d.yMean).text(metric);
  });

  categoryNA.exit().remove();
};

continuousColumn.updateViolin = function (_g, data, tweenTime) {

  var violinArea = d3.area().x0(function (d) {
    return d.pos.x0;
  }).x1(function (d) {
    return d.pos.x1;
  }).y(function (d) {
    return d.pos.y;
  }).curve(d3.curveCatmullRom);

  _.each(data.column.violinData, function (d, i) {
    d.pos = {};
    d.pos.y = data.column.scaleY(d.mean);
    if (i === 0) d.pos.y = data.column.scaleY(d.x0);
    if (i === data.column.violinData.length - 1) d.pos.y = data.column.scaleY(d.x1);

    d.pos.x0 = -data.column.violinScaleX(d.length);
    d.pos.x1 = data.column.violinScaleX(d.length);
  });

  var violinPath = _g.selectAll('#violin-path').data([data.column]);

  violinPath.enter().append("path").attr('id', 'violin-path').attr('key', data.column.id).attr("d", function (d) {
    return violinArea(d.violinData);
  }).attr("stroke", drawUtils.colors.similarPatients.selected).attr("stroke-width", 0.5).attr("fill", drawUtils.colors.similarPatients.default).attr('fill-opacity', 0.25);

  violinPath.attr("d", function (d) {
    return violinArea(d.violinData);
  });

  violinPath.exit().remove();
};

continuousColumn.brushed = function (_g, id, brushedColumn, similarPatientsFilter) {

  //console.log(d3.event.selection);

  if (!d3.event.selection) {
    _g.selectAll('#html-brush-inputs').attr('visibility', 'hidden');
    //console.log('no event.selection')
    return;
  }

  //set input html values
  var range = [];
  var min = Number(brushedColumn.column.scaleY.invert(d3.event.selection[0]).toFixed(brushedColumn.brushProps.digits));
  range.push(min);
  var max = Number(brushedColumn.column.scaleY.invert(d3.event.selection[1]).toFixed(brushedColumn.brushProps.digits));
  range.push(max);
  if (range[0] > range[1]) range = _.sortBy(range, function (d) {
    return d;
  });

  similarPatientsFilter.brushedPatients[id] = [];

  _.each(brushedColumn.column.patients, function (patient) {
    if (patient.value >= range[0] && patient.value <= range[1]) {
      similarPatientsFilter.brushedPatients[id].push(patient);
      similarPatientsFilter.brushedSelection[id] = d3.event.selection;
    }
  });

  var htmlInputs = _g.selectAll('#html-brush-inputs').attr('visibility', 'visible').each(function (d, i) {
    d.value = range[i];
    var fObject = d3.select(this);
    fObject.select('#brushValue');

    var input = fObject.select('#brushValue');
    input.style('outline-color', '#1474A4').style('border', '1px solid #212121').style('color', '#212121').node().value = range[i];
  });

  //return similarPatientsFilter;
};

continuousColumn.brushEndend = function (id, similarPatientsFilter) {

  if (!d3.event.selection) {
    if (similarPatientsFilter.brushedPatients[id]) {
      delete similarPatientsFilter.brushedPatients[id];
      delete similarPatientsFilter.brushedSelection[id];
    }
  }

  return similarPatientsFilter;
};

module.exports = continuousColumn;